import {Component, Input} from '@angular/core';

@Component({
    selector: 'vui-panel',
    templateUrl: './panel.component.html',
    styleUrls: ['./panel.component.scss']
})
export class PanelComponent {
    @Input() public description: string;
    @Input() public title: string;
}
